import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthPageLayoutComponent } from '../../../shared/layout/auth-page-layout/auth-page-layout.component';
import { TwoFactorSetupComponent } from '../../profile/two-factor-setup/two-factor-setup.component';
import { AuthService } from '../../../shared/services/auth.service';

@Component({
  selector: 'app-two-factor-method-selection',
  imports: [AuthPageLayoutComponent, TwoFactorSetupComponent],
  templateUrl: './two-factor-method-selection.component.html',
})
export class TwoFactorMethodSelectionComponent implements OnInit {
  setupToken = '';
  setupIdentifier = '';

  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.setupToken = (sessionStorage.getItem('auth_force_2fa_setup_token') || '').trim();

    if (!this.isSetupTokenValid(this.setupToken)) {
      this.authService.clearPendingForceTwoFactorSetupToken();
      this.router.navigate(['/signin']);
      return;
    }

    const payload = this.authService.decodeAccessTokenPayload(this.setupToken) as { email?: unknown } | null;
    const identifierFromToken = typeof payload?.email === 'string' ? payload.email.trim() : '';
    this.setupIdentifier = identifierFromToken;
  }

  private isSetupTokenValid(token: string): boolean {
    if (!token) {
      return false;
    }

    const payload = this.authService.decodeAccessTokenPayload(token) as { email?: unknown } | null;
    if (!payload || typeof payload.email !== 'string' || !payload.email.trim()) {
      return false;
    }

    const expiryRaw = (sessionStorage.getItem('auth_force_2fa_setup_token_expiry_ms') || '').trim();
    const expiryMs = Number(expiryRaw);
    if (!Number.isFinite(expiryMs) || expiryMs <= 0) {
      return false;
    }

    return Date.now() < expiryMs;
  }

  cancelToLogin(): void {
    this.authService.logout();
    this.router.navigate(['/signin']);
  }
}
